/**
 * Hanami UI — point d'entrée principal.
 * L'import enregistre les Web Components <hn-*> et active les déclencheurs data-hn-*.
 *
 *   import '@kawaiitenshi/hanami-ui/css';
 *   import { toast, setTheme } from '@kawaiitenshi/hanami-ui';
 */
import { installCommands } from './core/commands';
import type { HnCarousel, HnCopyButton, HnDialog, HnDrawer, HnDropdown, HnIcon, HnPetals, HnSidebar, HnTab, HnTabPanel, HnTabs, HnThemeToggle, HnTooltip } from './elements';
import type { HnToastRegion } from './core/toast';

export * from './elements';
export { toast, dismissAllToasts, setToastPosition, type ToastOptions, type ToastHandle, type ToastVariant, type ToastPosition, type ToastAction } from './core/toast';
export { setTheme, getTheme, getResolvedTheme, toggleTheme, initTheme, onThemeChange, themeScript, THEME_EVENT, THEME_STORAGE_KEY, type ThemeMode, type ResolvedTheme, type ThemeChangeDetail, type SetThemeOptions } from './core/theme';
export { registerIcon, getIcon, iconNames, iconSvg, type IconDefinition, type BuiltinIconName } from './icons';
export { setStrings, type HanamiStrings } from './core/strings';
export { computePosition, autoUpdate, type Placement, type PositionOptions } from './core/position';
export { installCommands } from './core/commands';
export * from './core/classes';
export { SAKURA_PATH, PETAL_PATH } from './core/shapes';

declare const __HANAMI_VERSION__: string;

/** Version du paquet Hanami UI. */
export const version: string = typeof __HANAMI_VERSION__ === 'string' ? __HANAMI_VERSION__ : 'dev';

installCommands();

declare global {
  interface HTMLElementTagNameMap {
    'hn-icon': HnIcon;
    'hn-sidebar': HnSidebar;
    'hn-dialog': HnDialog;
    'hn-drawer': HnDrawer;
    'hn-tabs': HnTabs;
    'hn-tab': HnTab;
    'hn-tab-panel': HnTabPanel;
    'hn-dropdown': HnDropdown;
    'hn-tooltip': HnTooltip;
    'hn-carousel': HnCarousel;
    'hn-petals': HnPetals;
    'hn-theme-toggle': HnThemeToggle;
    'hn-copy-button': HnCopyButton;
    'hn-toast-region': HnToastRegion;
  }
}
